import React, { FunctionComponent, Fragment } from 'react';
import { Route } from 'react-router-dom';
import NetworkCreateDialog from 'routes/Network/containers/NetworkCreateDialog';
import DialedDigitExtractionServerList from './containers/CfFtpInfoList';
import DialedDigitExtractionServerCreate from './containers/CfFtpInfoCreate';
import DialedDigitExtractionServerEdit from './containers/CfFtpInfoEdit';
import CfFtpInfoView from './containers/CfFtpInfoView';
import {
  SYSTEM_CONFIGURATION_ROUTE,
  CF_FTP_INFO_ROUTE,
  MISCELLANEOUS
} from '../../constants';

interface Props {
}

const CfFtpInfo: FunctionComponent<Props> = () => {
  return (
    <Fragment>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CF_FTP_INFO_ROUTE}`}>
        <DialedDigitExtractionServerList />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CF_FTP_INFO_ROUTE}/create`}>
        <DialedDigitExtractionServerCreate />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CF_FTP_INFO_ROUTE}/edit`}>
        <DialedDigitExtractionServerEdit />
      </Route>
      <Route exact path={`${SYSTEM_CONFIGURATION_ROUTE}${MISCELLANEOUS}${CF_FTP_INFO_ROUTE}/view`}>
        <CfFtpInfoView />
      </Route>
      <NetworkCreateDialog />
    </Fragment>
  );
};

export default CfFtpInfo;
